export const stripeConfirmIntent = ({ stripe, clientSecret, data, }) => {
    return stripe?.confirmCardSetup(clientSecret, data);
};
